import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery  } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    billingAccount: null,
    error: false,
};

export const createBillingAccount = createAsyncThunk("dealers/views/.components/createEditBillingAccount/redux/slice/createBillingAccount", async (payload, { rejectWithValue, dispatch }) => {
    const { name, dealerId } = payload;
    try {
        let response = await clientMutation(`
            mutation createBillingAccount($name: String!, $dealerId: Int!) {
                result: createBillingAccount(name: $name, dealerId: $dealerId) {
                    id
                }
            }`,
            {
                name: name,
                dealerId: dealerId
            },
            endpoints.GRAPHQL_GENERAL
        );
        return { result: response?.result };
    } catch (exc) {
        return rejectWithValue(exc);
    }
}
)

export const updateBillingAccount = createAsyncThunk("dealers/views/.components/createEditBillingAccount/redux/slice/updateBillingAccount", async (payload, { rejectWithValue, dispatch }) => {
    const { name, id, dealerId } = payload;
    try {
        let response = await clientMutation(`
            mutation updateBillingAccount($name: String!, $id: Int!, $dealerId: Int!) {
                result: updateBillingAccount(name: $name, id: $id, dealerId: $dealerId) {
                    id
                }
            }`,
            {
                name: name,
                id: id,
                dealerId: dealerId
            },
            endpoints.GRAPHQL_GENERAL
        );
        return { result: response?.result };
    } catch (exc) {
        return rejectWithValue(exc);
    }
}
)


export const createEditBillingAccountRedux = createSlice({
    name: 'dealers/billingAccount/createEditBillingAccount',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalCreateEditBillingAccount(state, action) {
            state.openModal = true
            state.billingAccount = action.payload
        }
    },
    extraReducers: (builder) => {
        // Create billing account
        builder.addCase(createBillingAccount.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(createBillingAccount.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(createBillingAccount.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error || "";
        });

        // Update billing account
        builder.addCase(updateBillingAccount.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(updateBillingAccount.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(updateBillingAccount.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error || "";
        });
    }
});

const { actions, reducer } = createEditBillingAccountRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalCreateEditBillingAccount
} = actions;

export default reducer;